import { render, staticRenderFns } from "./RemainingCartOrder.vue?vue&type=template&id=5357828e&scoped=true"
import script from "./RemainingCartOrder.vue?vue&type=script&lang=js"
export * from "./RemainingCartOrder.vue?vue&type=script&lang=js"
import style0 from "./RemainingCartOrder.vue?vue&type=style&index=0&id=5357828e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5357828e",
  null
  
)

export default component.exports